import React from "react";
import { FaWhatsapp } from "react-icons/fa";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
        <div className="col-lg-1">
            <img 
                src="../img/logo-no_bg-color.png"
                alt="Logo Tuboflex"
                style={{ maxWidth: '400px', height: 'auto', marginTop: '5px' }}
            />
        </div>
        <div className="col-lg-11">
            <div className="container">
                {/*<div className="navbar-header">
                    <button
                        type="button"
                        className="navbar-toggle collapsed"
                        data-toggle="collapse"
                        data-target="#bs-example-navbar-collapse-1"
                    >{" "}
                        <span className="sr-only">Toggle navigation</span>{" "}
                        <span className="icon-bar"></span>{" "}
                        <span className="icon-bar"></span>{" "}
                        <span className="icon-bar"></span>{" "}
                    </button>
                {/* <a className="navbar-brand page-scroll" href="#page-top">
                    Omega Prepress Studio
                </a>{" "} */}
                {/* </div>  */}
                <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                    {/* <ul className="nav navbar-nav navbar-left">
                        <li>
                            <a href="#contact" className="page-scroll">
                                Contato
                            </a>
                        </li>
                    </ul> */}
                    <ul className="nav navbar-nav navbar-center">
                    <li>
                        <a href="https://wa.me/5519983605031">
                            <button className="btnFaleConosco" >
                                <FaWhatsapp />
                            </button>
                        </a>
                    </li>
                 </ul>
                </div>
            </div>
        </div>
    </nav>
  );
};
